import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { Subscription } from "rxjs";
import { UserService } from "../../../shared";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { ReportService } from "../../Report/report.service";
import { ReportFileTypeDialogComponent } from "../shared/report-file-type-dialog/report-file-type-dialog.component";
import { DataService_Student_Scan_History } from "./shared/data.service";
import { ScanTableRequestModel } from "./shared/ScanTableRequestModel";
import * as moment from "moment";

@Component({
	selector: "app-student-scan-history",
	templateUrl: "./student-scan-history.component.html",
	styleUrls: ["./student-scan-history.component.css"],
})
export class StudentScanHistoryComponent implements OnInit {
	constructor(
		private userService: UserService,
		private ScanHistoryService: DataService_Student_Scan_History,
		private selectService: PersonSelectorService,
		private reportService: ReportService,
		private dialogService: DialogService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		//
		// Get data from DB
		//
		this.loadStationMode();
		this.loadScanResult();

		this.subscription = this.selectService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;

			//
			// RESET Mode when selected person changes
			// (so users don't accidently try to get too many results)
			//
			// this.ModeSelectID = 0;

			// this.loadStats();
			this.loadScan();
		});

		this.lstPersonSubscription = this.selectService.onTableChange().subscribe((persons) => {
			this.lstPerson = persons;

			//
			// RESET Mode when table changes
			// (so users don't accidently try to get too many results)
			//
			// this.ModeSelectID = 0;

			// this.loadStats();
			this.loadScan();
		});

		this.FilterSub = this.selectService.onFilterChange().subscribe((params) => {
			this.DynamicGroupID = params.dynamicGroupID;
			this.DynamicGroupValue = params.dynamicGroupValueID;
			this.Active = params.StatusID;
			this.FilterText = params.searchQuery;
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
		this.lstPersonSubscription.unsubscribe();
		this.FilterSub.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	//
	// For reports
	//
	lstStationMode: any = [];
	lstScanResult: any = [];

	FilterSub: Subscription;

	DynamicGroupID: any = 1;
	DynamicGroupValue: any = 0;
	Active: any = 2;
	FilterText: any = "";

	isShowInfo: any = false;

	ModeSelectID: any = 0; //Current or All

	lstMode: any = [
		{
			ID: 0,
			Desc: "Current Student Only",
		},
		{
			ID: 1,
			Desc: "All Students in Table",
		},
	];

	//Person Selector
	subscription: Subscription;
	SelectedPerson: any;

	// Stats
	StatLoading: boolean = false;
	TotalScans: string = "0";
	EntryScans: string = "0";
	ExitScans: string = "0";
	MealScans: string = "0";
	AccessScans: string = "0";
	TimestampScans: string = "0";
	EventScans: string = "0";
	ManualScans: string = "0";
	TempIDCount: string = "0";
	NewIDCount: string = "0";

	//Get list of persons (for loading scans)
	lstPersonSubscription: Subscription;
	lstPerson: any = [];

	isProcessing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	ScanLoading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedScan: any;
	lstScan: any = [];

	//Filter lists
	lstStationModeDesc: any = [];
	lstResultDesc: any = [];
	lstScanStation: any = [];
	lstManualDesc: any = [];
	lstFacilityName: any = [];
	lstFacilityLocationName: any = [];
	lstHasAlertDesc: any = [];
	lstHasReminderDesc: any = [];
	lstOnBlockListDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "PersonName", header: "Name" },
		{ field: "ScanDTDesc", header: "Date" },
		{ field: "StationModeDesc", header: "Station Mode" },
		{ field: "ResultDesc", header: "Scan Result" },
		{ field: "ScanStation", header: "ScanStation" },
		{ field: "ManualDesc", header: "Manual" },
		{ field: "FacilityName", header: "Facility" },
		{ field: "FacilityLocationName", header: "Location" },
		{ field: "HasAlertDesc", header: "Scan Has Alert" },
		{ field: "HasReminderDesc", header: "Scan Has Reminder" },
		// { field: "OnBlockListDesc", header: "Student On Block List" },
	];

	///////////////

	StartDate: any = new Date();
	EndDate: any = new Date();

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////
	loadStationMode() {
		var result = this.ScanHistoryService.StationModeList();
		result.subscribe(
			(response) => {
				this.lstStationMode = response;
			},
			(error) => {}
		);
	}

	loadScanResult() {
		var result = this.ScanHistoryService.ScanResultInfoSelectList();
		result.subscribe(
			(response) => {
				this.lstScanResult = response;
			},
			(error) => {}
		);
	}

	loadStats() {
		//
		// Only show stats when 1 student is selected
		//
		if (this.ModeSelectID != 0 || this.StartDate == undefined || this.EndDate == undefined) {
			this.StatLoading = false;
			return;
		}

		this.StatLoading = true;

		//Format dates
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (
			String(fsDate).toLowerCase().indexOf("invalid") != -1 ||
			String(feDate).toLowerCase().indexOf("invalid") != -1 ||
			this.SelectedPerson == undefined
		) {
			this.StatLoading = false;
			return;
		}

		this.SetStatLoadingValues();

		var parms: ScanTableRequestModel = {
			StartDate: fsDate,
			EndDate: feDate,
			PersonIDs: [this.SelectedPerson.PersonID],
		};

		var result = this.ScanHistoryService.StudentScanStatsSelect(parms);
		result.subscribe(
			(response: any) => {
				this.TotalScans = response.TotalScans;
				this.EntryScans = response.EntryScans;
				this.ExitScans = response.ExitScans;
				this.MealScans = response.MealScans;
				this.AccessScans = response.AccessScans;
				this.TimestampScans = response.TimestampScans;
				this.EventScans = response.EventScans;
				this.ManualScans = response.ManualScans;
				this.TempIDCount = response.TempIDCount;
				this.NewIDCount = response.NewIDCount;

				this.StatLoading = false;
			},
			(error) => {
				this.StatLoading = false;
			}
		);
	}

	loadScan() {
		this.ScanLoading = true;
		this.SelectedScan = null;

		//Format dates
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (
			String(fsDate).toLowerCase().indexOf("invalid") != -1 ||
			String(feDate).toLowerCase().indexOf("invalid") != -1 ||
			this.SelectedPerson == undefined
		) {
			this.ScanLoading = false;
			return;
		}

		//
		// Create Request Model
		//

		var lstPersonIDs: number[] = [];

		//
		// If using all students in table mode:
		// Go through person selector table and get Person IDs
		//
		if (this.ModeSelectID == 1) {
			//1, All

			for (var i = 0; i < this.lstPerson.length; i++) {
				var next = this.lstPerson[i];

				lstPersonIDs = [...lstPersonIDs, next.PersonID];
			}
		} else {
			lstPersonIDs = [...lstPersonIDs, this.SelectedPerson.PersonID];
		}

		var parms: ScanTableRequestModel = {
			StartDate: fsDate,
			EndDate: this.ModeSelectID == 0 ? feDate : fsDate, //When selecting multiple, only let the user select 1 day
			PersonIDs: lstPersonIDs,
		};

		var result = this.ScanHistoryService.StudentScanTableInfoSelectList(parms);
		result.subscribe(
			(response) => {
				this.lstScan = response;

				for (var i = 0; i < this.lstScan.length; i++) {
					var next = this.lstScan[i];

					next.ScanDTDesc = moment(new Date(next.ScanDT)).format("MM/DD/YYYY h:mm:ss a");
				}

				//Load Data Filter Lists
				this.lstStationModeDesc = Array.from(new Set(this.lstScan.map((item: any) => item.StationModeDesc))).sort();
				this.lstResultDesc = Array.from(new Set(this.lstScan.map((item: any) => item.ResultDesc))).sort();
				this.lstScanStation = Array.from(new Set(this.lstScan.map((item: any) => item.ScanStation))).sort();
				this.lstManualDesc = Array.from(new Set(this.lstScan.map((item: any) => item.ManualDesc))).sort();
				this.lstFacilityName = Array.from(new Set(this.lstScan.map((item: any) => item.FacilityName))).sort();
				this.lstFacilityLocationName = Array.from(new Set(this.lstScan.map((item: any) => item.FacilityLocationName))).sort();
				this.lstHasAlertDesc = Array.from(new Set(this.lstScan.map((item: any) => item.HasAlertDesc))).sort();
				this.lstHasReminderDesc = Array.from(new Set(this.lstScan.map((item: any) => item.HasReminderDesc))).sort();
				this.lstOnBlockListDesc = Array.from(new Set(this.lstScan.map((item: any) => item.OnBlockListDesc))).sort();

				this.ScanLoading = false;
				this.loadStats();
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onToggleInfo() {
		this.isShowInfo = !this.isShowInfo;
	}

	onRefresh() {
		// this.loadStats();
		this.loadScan();
	}

	//Custom Button Methods
	onPrint() {
		this.errorMessage = "";

		//Error handling

		if (this.SelectedPerson == undefined) {
			this.errorMessage = "Select a person to print attendance records";
		}

		var ref = this.dialogService.open(ReportFileTypeDialogComponent, {
			header: "Report File Type",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response > 0) {
				this.FinishPrint(response);
			}
		});
	}

	FinishPrint(OutputType) {
		//
		// Format Dates
		//
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		//
		// Get data from table dropdowns
		//

		// Station Mode
		var SM: any = "0";
		var SMFilter = <HTMLElement>document.getElementById("StationModeDesc").children[0].children[0].children[0];

		if (SMFilter.innerText != "Any") {
			var SMDesc = SMFilter.innerText;

			for (var i = 0; i < this.lstStationMode.length; i++) {
				var next = this.lstStationMode[i];

				if (next.StationModeDesc == SMDesc) {
					SM = String(next.StationModeID);
					break;
				}
			}
		}

		// Scan Result
		var SR = "0";
		var SRFilter = <HTMLElement>document.getElementById("ResultDesc").children[0].children[0].children[0];
		if (SRFilter.innerText != "Any") {
			var SRDesc = SRFilter.innerText;

			for (var i = 0; i < this.lstScanResult.length; i++) {
				var next = this.lstScanResult[i];

				if (String(next.ScanResultDesc) == String(SRDesc)) {
					SR = String(next.ScanResultID);
					break;
				}
			}
		}

		// Has Alert
		var HA = "-1";
		var HAFilter = <HTMLElement>document.getElementById("HasAlertDesc").children[0].children[0].children[0];
		if (HAFilter.innerText != "Any") {
			if (HAFilter.innerText == "Yes") {
				HA = "1";
			} else {
				HA = "2";
			}
		}

		// Is Manual
		var IM = "-1";
		var IMFilter = <HTMLElement>document.getElementById("ManualDesc").children[0].children[0].children[0];
		if (IMFilter.innerText != "Any") {
			if (IMFilter.innerText == "Yes") {
				IM = "1";
			} else {
				IM = "2";
			}
		}

		//
		// First and last name
		//
		var fName: any = "";
		var lName: any = "";

		//
		// Based on person selector
		// No spaces: assume last name
		// ex. bailey
		//
		if (String(this.FilterText).indexOf(" ") == -1) {
			lName = this.FilterText;
		} else {
			//ex. %raven bailey
			var splitInd: number = 0;

			splitInd = String(this.FilterText).indexOf(" ");
			fName = String(this.FilterText).substring(0, splitInd);
			lName = String(this.FilterText).substring(splitInd);
		}

		//Call SP

		var component = this;
		this.isProcessing = true;

		var strParam = "";

		//Parameter 1: EnrollmentTypeID
		strParam += 1 + "|EnrollmentTypeID";

		// console.log(this.DynamicGroupID);

		//Parameter 2: DynamicGroupID
		strParam += "," + this.DynamicGroupID + "|DynamicGroupID";

		//Parameter 3: DynamicGroupValue
		strParam += "," + this.DynamicGroupValue + "|DynamicGroupValue";

		//Parameter 4: LastName
		strParam += "," + lName + "|LastName";

		//Parameter 5: FirstName
		strParam += "," + fName + "|FirstName";

		//Parameter 6: Active
		strParam += "," + this.Active + "|Active";

		//Parameter 7: FilterUnAssignedMealSubsidy
		strParam += "," + 0 + "|FilterUnAssignedMealSubsidy";

		//Parameter 8: StationModeID
		strParam += "," + SM + "|StationModeID";

		//Parameter 9: ScanResultID
		strParam += "," + SR + "|ScanResultID";

		//Parameter 10: EventID
		strParam += "," + -1 + "|EventID";

		//Parameter 11: CourseTypeID
		strParam += "," + -1 + "|CourseTypeID";

		//Parameter 12: TimeScanTypeID
		strParam += "," + -1 + "|TimeScanTypeID";

		//Parameter 13: HasAlert
		strParam += "," + HA + "|HasAlert";

		//Parameter 14: HasAttendance
		strParam += "," + -1 + "|HasAttendance";

		//Parameter 15: IsManual
		strParam += "," + IM + "|IsManual";

		//Parameter 16: StudentPersonID
		if (this.ModeSelectID == 0) {
			strParam += "," + this.SelectedPerson.PersonID + "|StudentPersonID";
		} else {
			strParam += "," + -1 + "|StudentPersonID";
		}

		//Parameter 17: Start Date
		strParam += "," + fsDate + "|StartDate";

		//Parameter 18: End Date
		if (this.ModeSelectID == 0) {
			strParam += "," + feDate + "|EndDate";
		} else {
			//
			// 1 Day for select all mode
			//
			strParam += "," + fsDate + "|EndDate";
		}

		var reportID: any = 282;

		//Add type selector
		var result = this.reportService.Print(reportID, strParam, this.SelectedPerson.SchoolID, OutputType);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onModeChange(val) {
		this.ModeSelectID = val;

		// this.loadStats();
		this.loadScan();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedScan = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedScan = null;
	}

	onStartDateChange(val) {
		this.errorMessage = "";

		this.StartDate = val;

		//
		// RESET Mode when date changes
		// (so users don't accidently try to get too many results)
		//
		// this.ModeSelectID = 0;

		// this.loadStats();
		this.loadScan();
	}

	onEndDateChange(val) {
		this.errorMessage = "";

		this.EndDate = val;

		//
		// RESET Mode when date changes
		// (so users don't accidently try to get too many results)
		//
		// this.ModeSelectID = 0;

		// this.loadStats();
		this.loadScan();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.isProcessing == true || this.ScanLoading == true || this.StatLoading == true;
	}

	SetStatLoadingValues() {
		this.TotalScans = "...loading";
		this.EntryScans = "...loading";
		this.ExitScans = "...loading";
		this.MealScans = "...loading";
		this.AccessScans = "...loading";
		this.TimestampScans = "...loading";
		this.EventScans = "...loading";
		this.ManualScans = "...loading";
		this.TempIDCount = "...loading";
		this.NewIDCount = "...loading";
	}

	////////////////////////////////////////////
}
